// "Acaba de pagar y debe el onboarding de marca", sobreviviendo una recarga
// (ADR-2026-10-31-onboarding-corto-para-la-prueba).
//
// El plan lo escribe sólo el webhook. Mientras no llega, la base dice `gratis` y la regla
// (`onboardingQueSeDebe`) no exige nada. El flag en memoria lo cubre en la pestaña, pero una
// recarga lo pierde: en ese rato, recargar en el primer paso del onboarding (el corte lo mandaba
// al estudio) o en la facturación (sin flag, "Continuar" entraba a la app) era una salida.
//
// Esto lo guarda en `sessionStorage`: es de la pestaña, como el pago, y muere con ella. Va con el
// usuario (una sesión de otra cuenta en la misma pestaña no lo hereda) y con vencimiento: pasado
// ese rato el webhook ya escribió el plan y la regla de siempre alcanza.

const CLAVE = 'atlas:pago-con-marca-pendiente';
export const VIGENCIA_MS = 30 * 60 * 1000;

interface Marca {
  userId: string;
  hasta: number;
}

export function recordarPagoConMarcaPendiente(userId: string, ahora = Date.now()): void {
  try {
    sessionStorage.setItem(CLAVE, JSON.stringify({ userId, hasta: ahora + VIGENCIA_MS } satisfies Marca));
  } catch {
    /* sin storage, queda el flag en memoria */
  }
}

/** ¿Este usuario acaba de pagar en esta pestaña y todavía debe el onboarding de marca? */
export function pagoConMarcaPendiente(userId: string | null | undefined, ahora = Date.now()): boolean {
  if (!userId) return false;
  try {
    const crudo = sessionStorage.getItem(CLAVE);
    if (!crudo) return false;
    const m = JSON.parse(crudo) as Partial<Marca>;
    return m.userId === userId && typeof m.hasta === 'number' && m.hasta > ahora;
  } catch {
    return false;
  }
}

export function olvidarPagoConMarcaPendiente(): void {
  try {
    sessionStorage.removeItem(CLAVE);
  } catch {
    /* nada que olvidar */
  }
}
